import Widget from './Widget'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  nonIABVendorsAuthorized: state.consentManagement.nonIABVendorsAuthorized,
  locale: state.router.locale,
})

export default connect(
  mapStateToProps,
)(Widget)
